/*
 * Archives (era terminals) recolor — RECENT-CHANGES-HANDOFF.md item 3. Was
 * navy/blue-on-blue; now warm rust/amber to match the rest of the site. A small
 * patch rather than a hand-edit to sat-app.js: only the "archives" entry in each
 * of the three page-chrome lookup objects, plus the archives stats tiles, ever
 * needed to change.
 *
 * Also drops the "EARLIEST 1974" stat tile (a founding-date claim that isn't
 * true) in favor of a RECORDS count, per the merchant's request to remove
 * every place the site implies a specific founding year.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var self = this;
    var s = this.state;

    if (s.page === 'archives') {
      out.pageAccent = '#E0A23D';
      out.pageBandBg = '#3A2418';
      out.pageGlow = 'rgba(224,162,61,.24)';
    }
    if (Array.isArray(out.pageStats) && s.page === 'archives' && out.pageStats[0]) {
      out.pageStats = out.pageStats.map(function (tile, i) {
        if (i === 0) return Object.assign({}, tile, { color: '#E0A23D' });
        if (i === 1) return { label: 'RECORDS', value: String((self._products || []).length).padStart(2, '0'), color: '#F4EFE3' };
        return tile;
      });
    }

    return out;
  };
})();
